module.exports = __webpack_public_path__ + "images/400.gif";